import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import Navigation from '../Navigation/Navigation'
import PeriodeMonitoringService from './PeriodeMonitoringService'
import AuthorizationFilter from '../Authorization/AuthorizationFilter'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'

import './VNB/PeriodeMonitoringVNB'

export default class PeriodeMonitoring extends WebComponent {

  constructor() {
    super()
    this.periodeMonitoringService = new PeriodeMonitoringService()
  }

  get translationFile() {
    return './views/PeriodeMonitoring/i18n.json'
  }

  get subsites() {
    return {
      VNBPeriode: {
        render: () => html`
          <eko-frontend-kontingentierung-periode-vnb></eko-frontend-kontingentierung-periode-vnb>`
      }
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    if (getNavigationId() !== undefined) {
      Promise.resolve(
        this.periodeMonitoringService.read(getNavigationId())
      ).then(json => {
        this.periode = json
        this.render()
      })
    }
  }

  getTemplate() {
    const subsite = this.subsites[getNavigationHash()]
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('page.title',
        {von: formatDate(this.periode.start), bis: formatDate(this.periode.ende)})}"
      ></isceco-title>
      <div class="detail-flex-box">
        <div class="detail-child-left">
          <isceco-vertical-navigation .items="${this._getNavItems()}">
          </isceco-vertical-navigation>
        </div>
        <div class="detail-child-right">
          ${subsite.render()}
        </div>
      </div>
    `
  }

  _getNavItems = () => {
    const roles = new AuthorizationFilter().roles
    return [
      {
        text: this.i18n.translate('navigation.back'),
        icon: 'long arrow alternate left',
        url: `${Navigation.ROUTES.monitoringVerordnung.url}/${this.periode.verordnungId}`,
        roles: [roles.BWL, roles.OSTRAL, roles.VNB]
      },
      {
        text: this.i18n.translate('navigation.verteilnetzbetreiber'),
        icon: 'table',
        url: `${Navigation.ROUTES.monitoringPeriodeVnb.url}/${getNavigationId()}`,
        suburls: [Navigation.ROUTES.monitoringPeriodeVnb.url],
        roles: [roles.BWL, roles.OSTRAL]
      },
      // {
      //   text: this.i18n.translate('navigation.geschaeftspartner'),
      //   icon: 'table',
      //   url: `${Navigation.ROUTES.monitoringVerbrauch.url}/${getNavigationId()}`,
      //   suburls: [Navigation.ROUTES.monitoringVerbrauch.url],
      //   roles: [roles.BWL, roles.OSTRAL, roles.VNB]
      // }
    ].filter(i => i.roles.some(r => r))
  }
}

customElements.define('eko-frontend-kontingentierung-periode', PeriodeMonitoring)
